import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5025/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

export const friendsService = {
  // Get user relations (friends, following, followers, blocked)
  getRelations: async () => {
    const response = await axios.get(`${API_URL}/friends`, getAuthHeaders());
    return response.data;
  },

  // Add / follow a user
  addFriend: async (targetUserId) => {
    const response = await axios.post(`${API_URL}/friends/add`, { targetUserId }, getAuthHeaders());
    return response.data;
  },

  // Remove / unfollow a user
  removeFriend: async (targetUserId) => {
    const response = await axios.delete(`${API_URL}/friends/remove/${targetUserId}`, getAuthHeaders());
    return response.data;
  },

  // Block a user
  blockUser: async (targetUserId) => {
    const response = await axios.post(`${API_URL}/friends/block/${targetUserId}`, {}, getAuthHeaders());
    return response.data;
  },

  // Unblock a user
  unblockUser: async (targetUserId) => {
    const response = await axios.delete(`${API_URL}/friends/unblock/${targetUserId}`, getAuthHeaders());
    return response.data;
  },

  // Search registered users to add as friends
  searchUsers: async (query) => {
    const response = await axios.get(`${API_URL}/friends/search?q=${encodeURIComponent(query)}`, getAuthHeaders());
    return response.data;
  },

  // Get friend's active ongoing game for spectating
  getFriendActiveGame: async (friendId) => {
    const response = await axios.get(`${API_URL}/friends/${friendId}/active-game`, getAuthHeaders());
    return response.data;
  }
};

export default friendsService;
